import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicAPIServices from '../../services/publicAPIServices';

const initialState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  message: ''
};

export const fetchBracDataBySlug = createAsyncThunk('brac/fetchBySlug', async (fetchURL, thunkAPI) => {
  try {
    return await publicAPIServices.fetchDataBySlug(fetchURL);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const bracSlice = createSlice({
  name: 'brac',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBracDataBySlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBracDataBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchBracDataBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.data = null;
      });
  }
});

export const { reset } = bracSlice.actions;
export default bracSlice.reducer;
